import './loadingOverlay.scss';
import PropTypes from 'prop-types';

function HesSpinner({height, width, maxHeight, maxWidth}) {
  return (
    <div className="spinner-1" style={{height: height ? height : '', width: width ? width : '', maxHeight: maxHeight ? maxHeight : '', maxwidth: maxWidth ? maxWidth : ''}}>
      <svg
        className="spinner"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
        viewBox="0, 0, 400,390.2439024390244">
        <path
          className="spinner__leaf"
          d="M88 220c-16 18-24 102-12 120 16 23 54 4 45-21-4-12-8-42-8-68-1-49-6-55-25-31"
        />
        <path
          className="spinner__leaf"
          d="M83 155c-39 23-83 76-83 98 0 25 48 45 55 23 14-46 37-92 54-106 36-34 19-43-26-15"
        />
        <path
          className="spinner__leaf"
          d="M43 112c-39 16-46 27-30 48 11 16 15 15 56-8 24-14 51-25 60-25 22 0 23-16 2-24-24-9-55-6-88 9"
        />
        <path
          className="spinner__leaf"
          d="M55 36c-23 23-5 60 27 55 20-3 53 1 80 10 53 18 63 15 38-13C166 50 74 17 55 36"
        />
        <path
          className="spinner__leaf"
          d="M164 16c-14 14-11 19 34 63 57 55 56 54 56 28 0-59-61-121-90-91"
        />
        <path
          className="spinner__leaf"
          d="M249 28c-3 5-1 21 5 35 5 14 9 48 9 74 0 27 5 48 11 48 25 0 48-108 32-150-6-17-48-21-57-7"
        />
        <path
          className="spinner__leaf"
          d="M312 141c-6 18-20 45-31 59-27 35-17 40 25 13 46-30 76-83 55-96-26-16-37-11-49 24"
        />
        <path
          className="spinner__leaf"
          d="M341 201c-17 21-82 53-106 53-29 0-25 18 5 25 76 19 159-20 135-65-17-33-17-33-34-13"
        />
        <path
          className="spinner__leaf"
          d="M176 272c0 20 59 62 96 67 38 5 40 4 40-21 0-23-4-25-34-25-19 0-50-7-69-14-18-8-33-11-33-7"
        />
        <path
          className="spinner__leaf"
          d="M122 243c-17 28 45 147 77 147 20 0 53-41 37-46-22-8-72-54-90-83-10-18-20-24-24-18"
        />
      </svg>
    </div>

  );
}

HesSpinner.propTypes = {
  height: PropTypes.string,
  width: PropTypes.string,
  maxHeight: PropTypes.string,
  maxWidth: PropTypes.string
};


export default HesSpinner;